import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c6ca94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 提示 ", -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "系统检测到当前提单为非现场提单，您可以使用一次豁免机会进行系统自动豁免。请确认是否使用该权益？", -1))
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = { class: "btn-wrap" }

import {Dialog} from 'vant'
import {ref} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'on-site-system-tip-dialog',
  props: {
  remainNum: {
    type: Number,
    default: 0
  }
},
  emits: ['confirm'],
  setup(__props, { expose, emit: emits }) {

const props = __props;






expose({
  setShow(value: boolean) {
  show.value = value
}
})

const show = ref(false)



function clickHandle (flag: number) {
  show.value = false
  emits('confirm', flag)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog).Component, {
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    "get-container": "body"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "cancel-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandle(0)))
        }, "不使用系统豁免"),
        _createElementVNode("div", {
          class: "confirm-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandle(1)))
        }, "使用豁免机会")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, "（本次豁免后剩余" + _toDisplayString(`${props.remainNum}`) + "次豁免权益）", 1)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})